webpackJsonp([94],{

/***/ 2403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetEmail_vue__ = __webpack_require__(3536);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b453f2d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetEmail_vue__ = __webpack_require__(4287);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4285)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b453f2d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/account/SetEmail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b453f2d", Component.options)
  } else {
    hotAPI.reload("data-v-0b453f2d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_AccountRepository__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BAlert: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* BAlert */]
  },
  data: function data() {
    return {
      emailSetted: false,
      email: null,
      token: null,
      expiredPwd: false,
      error: null,
      submitError: null,
      form: {
        state: {
          submitted: false,
          waiting: false,
          unauthorized: false,
          errors: false
        }
      }
    };
  },
  created: function created() {
    var token = this.$route.query.t;

    if (!token) {
      this.$router.push('/unauthorized');
    } else {
      this.token = token;
    }
  },

  methods: {
    setEmail: function setEmail() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__repositories_AccountRepository__["a" /* default */].setEmail(this.email, this.token).then(function (response) {
        if (response.data) {
          _this.emailSetted = true;
        } else {
          _this.form.state.errors = true;
          _this.submitError = _this.$t('account.set-email.error01');
        }
      }).catch(function (error) {
        _this.form.state.errors = true;
        if (error.status === 401) {
          _this.confirmSucessful = false;
          _this.submitError = _this.$t('account.set-email.error01');
        } else if (error.status === 400) {
          _this.confirmSucessful = false;
          _this.submitError = _this.$t('account.set-email.error02');
        }
      });
    }
  },
  mounted: function mounted() {
    this.expiredPwd = !!this.$route.query.expired;
  }
});

/***/ }),

/***/ 4285:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4286);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1c5b2d31", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0b453f2d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SetEmail.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0b453f2d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SetEmail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4286:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 4287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.emailSetted
      ? _c(
          "div",
          [
            _vm.form.state.errors
              ? _c("b-alert", {
                  attrs: { show: "", variant: "danger" },
                  domProps: { innerHTML: _vm._s(_vm.submitError) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("account.set-email-title")))]),
            _vm._v(" "),
            _c("base-input", {
              attrs: { placeholder: "Email" },
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = $$v
                },
                expression: "email"
              }
            }),
            _vm._v(" "),
            _c(
              "base-button",
              { staticClass: "mt-3", on: { click: _vm.setEmail } },
              [_vm._v(_vm._s(_vm.$t("account.setEmail")))]
            )
          ],
          1
        )
      : _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.$t("account.confirm-account-message")))])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b453f2d", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/94.d5ece94478996ae33fe2.js